import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { InactiveFolioPaths } from '../types';
import CheckCircle from '@material-ui/icons/CheckCircle';

export const TrackIntermediate = () => {
    const history = useHistory();
    const {
        state: { pan, registerDetails, reqId },
    } =
        useLocation<{
            pan: string;
            registerDetails: { by: string; details: string };
            reqId: string;
        }>();
    return (
        <div className="curved-bg">
            <div
                style={{
                    backgroundColor: 'white',
                    height: '80%',
                    minHeight: '600px',
                    overflow: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div style={{ padding: '5vh 0' }}>
                    <h3
                        style={{
                            textAlign: 'center',
                            marginBottom: '3vh',
                            fontSize: '24px',
                        }}
                    >
                        Request ID: {reqId}
                    </h3>
                    <CheckCircle
                        style={{
                            width: '150px',
                            height: '150px',
                            display: 'block',
                            margin: '0 auto',
                            color: '#489A47',
                        }}
                    />
                    <p
                        style={{
                            padding: '2vh',
                            margin: '2vh 0',
                            fontSize: '24px',
                            textAlign: 'center',
                        }}
                    >
                        Your request has been accepted
                    </p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto' }}
                            onClick={() => {
                                history.replace(`/links${InactiveFolioPaths.TRACK}`, {
                                    pan,
                                    registerDetails,
                                    reqId,
                                });
                            }}
                        >
                            Track Request
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
